//============================================================================
// Name        : requestActions.ts
// Purpose     : Define store Receive actions
// Created     : 2019-08-26
// Author      : Daniel Ansari
// Copyright   : Copyright 2019 Senitron Corporation. All rights reserved.
//============================================================================

import {
    TagRequestActions,
    ITagRequestProps,
    IReasonOption,
    IReasonState,
    IUomState,
    IUomOption
} from "../types";

// Define base Action interface
export interface ITagRequestAction {
    type: TagRequestActions;
    payload: object;
}
//============================================================================
// Updates the store state with given values
//============================================================================
export interface IUpdateStateAction extends ITagRequestAction {
    payload: ITagRequestProps;
}

export function updateState(state: Partial<ITagRequestProps>, action: IUpdateStateAction): ITagRequestProps {
    return {
        ...state,
        ...action.payload,
    };
}

//============================================================================
// Store the selected reason in the store
//============================================================================
export interface ISetSelectedReasonAction extends ITagRequestAction {
    payload: IReasonOption;
}

export function setSelectedReason(state: IReasonState, action: ISetSelectedReasonAction): IReasonState {
    return {
        ...state,
        selectedReason: action.payload
    };
}

export interface ISetSelectedUomAction extends ITagRequestAction {
    payload: IUomOption;
}

export function setSelectedUom(state: IUomState, action: ISetSelectedUomAction): IUomState {
    return {
        ...state,
        selectedUom: action.payload
    };
}

export interface ISetReasonStateAction extends ITagRequestAction {
    props: Partial<IReasonState>;
}

export function setReasonState(state: IReasonState, action: ISetReasonStateAction): IReasonState {
    return {
        ...state,
        ...action.payload
    };
}

export interface ISetUomStateAction extends ITagRequestAction {
    props: Partial<IUomState>;
}

export function setUomState(state: IUomState, action: ISetUomStateAction): IUomState {
    return {
        ...state,
        ...action.payload
    };
}

export function continueTagRequest(state: Partial<ITagRequestProps>): ITagRequestProps {
    return {
        ...state as ITagRequestProps,
    };
}
